var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEllipse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 258,
    height: 130,
    viewBox: "0 0 258 130",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M258 129.5C258 95.1545 244.409 62.2156 220.217 37.9297C196.025 13.6437 163.213 2.59302e-06 129 0C94.7871 -2.59302e-06 61.9754 13.6437 37.7832 37.9297C13.591 62.2156 5.16601e-06 95.1544 0 129.5H38.7C38.7 105.458 48.2137 82.4009 65.1483 65.4008C82.0828 48.4006 105.051 38.85 129 38.85C152.949 38.85 175.917 48.4006 192.852 65.4008C209.786 82.4009 219.3 105.458 219.3 129.5H258Z",
    fill: "#FF0096"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEllipse);
export default __webpack_public_path__ + "static/media/ellipse.801a76b6b3700b487d9b5f6170b0d9e0.svg";
export { ForwardRef as ReactComponent };